import React from 'react'

import { withTranslation, WithTranslation } from 'react-i18next'

import classNames from 'classnames'

import dataManager from 'pages/main/data/DataManager'

import { getImageByRole } from 'pages/main/data/IconHelper'

import NormalItem from './normalItem'

// import styles from './style.module.scss'

interface MailboxItemProps extends WithTranslation {
  item: any
  indent?: boolean | number
  owner: any
  onClick?: (evt: any) => void
}

interface MailboxItemState {}

class MailboxItem extends React.Component<MailboxItemProps, MailboxItemState> {
  state: MailboxItemState = {}

  componentDidMount() {}

  componentWillUnmount() {}

  onClick = (evt: any) => {
    const { onClick, owner, item } = this.props
    // console.log(' onClick222 - ', evt)
    if (onClick != null) {
      onClick(evt)
    }

    owner.setSelectedItem(item.mailbox)
  }

  render() {
    const { item, indent, owner } = this.props
    const { mailbox } = item
    // const { data } = mailbox

    let cnt = 0
    let style: any = null

    if (indent === true) {
      let cur = mailbox
      while (cur != null && cur.data.parentId != null) {
        cnt += 1
        cur = dataManager.getMailboxById(cur.data.parentId)
      }
      const paddingLeft = 8 + 16 * cnt
      style = { paddingLeft: `${paddingLeft}px` }
    } else if (typeof indent === 'number') {
      style = { paddingLeft: `${indent}px` }
    }

    const displayName = mailbox.getDisplayName()
    const fullName = mailbox.getFullName()

    let label: any = ''
    if (displayName === fullName) {
      label = (
        <React.Fragment>
          <div className={classNames('shortName')}>{mailbox.getDisplayName()}</div>
        </React.Fragment>
      )
    } else {
      label = (
        <React.Fragment>
          <div className={classNames('shortName')}>{mailbox.getDisplayName()}</div>
          <div className={classNames('longName')}>{mailbox.getFullName()}</div>
        </React.Fragment>
      )
    }

    const role = mailbox.getRole()
    const itemProps: any = {
      classNames: classNames('mailboxItem', { selected: owner.getSelectedItem() === mailbox }),
      owner,
      item: {
        type: 'mailbox',
        icon: getImageByRole(role),
        label,
        key: mailbox.getId(),
      },
      onClickExt: this.onClick,
      testId: role != null && role !== '' ? `mailbox-${role}` : undefined,
      // wrapper: {
      //   elem: Popconfirm,
      //   props: {
      //     title: t('email.moveFolder.confirmMove'),
      //     placement: 'right',
      //     okText: t('common.button.ok'),
      //     cancelText: t('common.button.cancel'),
      //   },
      // },
    }

    if (style != null) {
      itemProps.style = style
    }

    return <NormalItem {...itemProps} />
  }
}

const MailboxItemDef = withTranslation()(MailboxItem)

export default MailboxItemDef
